import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Heading = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: "bolder"
}));

export const Placeholder = styled(Stack)(() => ({
  padding: "16px",
  flexDirection: "row",
  textAlign: "center",
  "& svg": { margin: "0 4px 0 0" }
}));
